import {
  CaretDownFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  Space,
  notification,
  Row,
  Select,
  Modal,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { NavBar } from '../../../compnents/nav/NavBar'
import { TenantQueryParams } from '../../../services/tenant'
import { ThemeContext } from '../../../theme/ThemeContext'
import { columns } from './PartnerColumns'
import { AddPartnerModel } from './AddPartnerModel'
import styles from './Partner.module.css'
import { useHistory, useLocation } from 'react-router-dom'
import {
  getOrganizationPartnerList,
  isChangeOrganizationStatus,
} from '../ReplaceMakeOrganizationSclice'
import { isEditSupplierPartner } from '../../replaceMakeCenter/ReplaceMakeSupplierSclice'

// 代煎机构合作的代煎饮片厂
export const OrganizationPartner = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const location: any = useLocation()

  const current = location.state?.current

  const [data, setData] = useState<any>()

  const [total, setTotal] = useState<any>()

  const [bindId, setBindId] = useState('')

  const options = [
    {
      value: 0,
      label: '全部',
    },
    {
      value: 1,
      label: '已绑定',
    },
    {
      value: 2,
      label: '已解绑',
    },
  ]

  const [params, setParams] = useState<TenantQueryParams>({
    size: 10,
    current: 1,
  })

  const [partnerId, setPartnerId] = useState('')

  const [isRelieveModel, setIsRelieveModel] = useState(false)

  const [isAddPartnerModel, setAddPartnerModelVisible] = useState(false)

  const [supplierName, setSupplierName] = useState('')

  useEffect(() => {
    getData()
  }, [params])

  const getData = () => {
    dispatch(
      getOrganizationPartnerList({
        ...params,
        tenantIds: location.state?.tenantId,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
  }

  return (
    <>
      <Col
        style={{
          height: 'calc(100% - 20px) ',
          overflow: 'hidden',
          margin: '10px 30px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <NavBar
          where={['代煎机构', '代煎设置']}
          backtrace={{
            name: '代煎机构',
            path: '/admin/replaceMakeCenter/replaceMakeOrganization',
            routeName: '代煎机构',
            state: {
              current,
            },
          }}
          buttons={
            <Button
              type='primary'
              icon={<PlusOutlined />}
              onClick={() => setAddPartnerModelVisible(true)}
            >
              {'新增饮片厂'}
            </Button>
          }
        />
        <Col
          style={{
            flex: 1,
            overflow: 'hidden',
            backgroundColor: theme.pn,
            marginTop: 10,
            borderRadius: 10,
            padding: '10px 15px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Form
            form={form}
            autoComplete='off'
            initialValues={{}}
            onFinish={(values) =>
              setParams({
                ...params,
                ...values,
              })
            }
          >
            <Row
              justify='space-between'
              align='middle'
              style={{ marginTop: 10, marginBottom: 20, width: '100%' }}
            >
              <Space>
              <Form.Item name='keyWord' noStyle>
                <Input
                  allowClear
                  placeholder='请输入机构名称/助记码'
                  prefix={<SearchOutlined />}
                  style={{ width: '315px' }}
                  onChange={form.submit}
                />
              </Form.Item>
                <Form.Item name='signedType' noStyle>
                  <Select
                    suffixIcon={
                      <CaretDownFilled style={{ color: theme.tc3 }} />
                    }
                    placeholder='签约状态'
                    onChange={form.submit}
                    style={{ width: '200px' }}
                  >
                    <Select.Option value={''}>全部</Select.Option>
                    <Select.Option value={1}>已签约</Select.Option>
                    <Select.Option value={0}>未签约</Select.Option>
                  </Select>
                </Form.Item>
              </Space>
              <Button type='primary' onClick={form.submit}>
                查询
              </Button>
            </Row>
          </Form>
          <EditableList
            page={{
              items: data,
              current: params.current || 1,
              size: params.size || 10,
              total,
            }}
            style={{ color: theme.tc3 }}
            className={styles.table}
            columns={columns(
              (action, t: any) => {
                switch (action) {
                  case 'relieve':
                    setSupplierName(t.name)
                    setBindId(t.bindingId)
                    setIsRelieveModel(true)
                    break
                  case 'setting':
                    setPartnerId(t.id)
                    setBindId(t.bindingId)
                    setAddPartnerModelVisible(true)
                    break
                  case 'againBind':
                    setPartnerId(t.id)
                    setBindId(t.bindingId)
                    setAddPartnerModelVisible(true)
                    break
                  case 'herbs':
                    history.push({
                      pathname: '/admin/replaceMakeCenter/HerbsDirectory',
                      state: {
                        id: location?.state?.tenantId,
                        status: 3,
                        supplierId: t.supplierId,
                        tenantId: location?.state?.tenantId,
                        platformId: location?.state?.platformId,
                        platformName: location?.state?.platformName,
                        tenantName: location?.state?.tenantName,
                      },
                    })
                    break
                }
              },
              (params.size || 10) * ((params.current || 1) - 1),
              theme
            )}
            onChangePage={(current: number, size?: number) =>
              setParams({
                ...params,
                current: current,
                size: size || 10,
              })
            }
            onRow={(t: any) => ({
              onDoubleClick: () => {
                setBindId(t.bindingId)
                setPartnerId(t.id)
                setAddPartnerModelVisible(true)
              },
            })}
          />
        </Col>
        <AddPartnerModel
          organizationName={location.state?.tenantName}
          partnerId={partnerId}
          bindId={bindId}
          tenantId={location.state?.tenantId}
          platformId={location.state?.platformId}
          platformName={location.state?.platformName}
          visible={isAddPartnerModel}
          onCancel={() => {
            setPartnerId('')
            setAddPartnerModelVisible(false)
          }}
          onOk={() => {
            setPartnerId('')
            setAddPartnerModelVisible(false)
            getData()
          }}
        />
        {/* 解除绑定弹框 */}
        <Modal
          visible={isRelieveModel}
          title={'解除绑定'}
          width={700}
          cancelText='取消'
          okText='确定'
          onCancel={() => {
            setIsRelieveModel(false)
          }}
          onOk={() => {
            dispatch(isEditSupplierPartner({ id: bindId, status: 2 }))
              .then(unwrapResult)
              .then(() => {
                getData()
              })
            isEditSupplierPartner
            setIsRelieveModel(false)
          }}
        >
          确认解除 {location.state?.tenantName} 与 {supplierName} 的绑定关系？
        </Modal>
      </Col>
    </>
  )
}
